import moment from 'moment-timezone';
import { formatMomentToValueDate } from './formatMomentToValueDate';
import { timing } from '@morf/proto/timing/v1/timing_ts_proto';
import { values } from '@morf/proto/values/v1/values_ts_proto';

export const formatTimestampToValueDate = (
  timestamp: timing.v1.Timestamp
): values.v1.Date => {
  const momentDate = moment.unix(timestamp.seconds.low);
  return formatMomentToValueDate(momentDate);
};
